import { CoreChartOptions } from 'chart.js';
import Link from 'next/link';
import { CompanyChartData } from 'lib/entities/company.types';
import CompanyChart from './CompanyChart';
import {
  ChartContainer,
  MainChartContent,
  MainChartWrapper,
  TimeframeButtonsDesktop,
} from './styled';
import { ChartTimeFrames } from '../constants.types';
import EmptyChart from './EmptyChart';
import { chartTimeframes } from '../constants';

interface MainChartProps {
  visible: boolean;
  symbol: string;
  timeframe: ChartTimeFrames;
  showTimeframes: boolean;
  onSelectTimeframe: (v: ChartTimeFrames) => void;
  isLoadingChart: boolean;
  chart: CompanyChartData;
  onClickChart: CoreChartOptions<'line'>['onClick'];
  disableChartbitLink?: boolean;
}

function MainChart({
  visible,
  symbol,
  timeframe,
  showTimeframes,
  onSelectTimeframe,
  isLoadingChart,
  chart,
  onClickChart,
  disableChartbitLink,
}: MainChartProps) {
  return !visible ? null : (
    <MainChartWrapper>
      <TimeframeButtonsDesktop
        showTimeframes={showTimeframes}
        timeframe={timeframe}
        onSelectTimeframe={onSelectTimeframe}
        timeFrameList={chartTimeframes}
      />
      <MainChartContent>
        {chart && (
          <ChartContainer>
            {disableChartbitLink ? (
              <CompanyChart chart={chart} onClickChart={onClickChart} />
            ) : (
              <Link href={`/symbol/${symbol}/chartbit`} passHref>
                <a rel="noopener noreferrer" target="_blank">
                  <CompanyChart chart={chart} onClickChart={onClickChart} />
                </a>
              </Link>
            )}
          </ChartContainer>
        )}
        {!isLoadingChart && !chart && <EmptyChart />}
      </MainChartContent>
    </MainChartWrapper>
  );
}

export default MainChart;
